import { registerVueComponentAndAngularBindings } from '/vodalys/vvuejs'
import VUserWelcome from './VUserWelcome.vue'

registerVueComponentAndAngularBindings('vuser:welcome', 'vuserWelcome', VUserWelcome)
